import * as yup from 'yup';

export const addSectionValidation =  yup.object({
    Name: yup.string().nullable().required('Section name is required'),
})